// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__3VyI_","drawer":"drawer__1Rsgv","active":"active__20mjT","right":"right__NohbI","left":"left__2RIX7"};


//////////////////
// WEBPACK FOOTER
// ../~/react-toolbox/lib/drawer/theme.css
// module id = uURc
// module chunks = 6